import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import { useI18n } from '@modules/i18n/composables';
import {
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_MERCHANT_SETTINGS_LIST_ROUTE_NAME,
  ADMIN_MERCHANT_SETTINGS_ROUTE_NAME,
  MERCHANT_SETTINGS_PERMISSIONS,
  TRANSLATION_GROUP_MERCHANT_SETTINGS,
} from './constants';
import { MerchantSettingsEditModule } from './submodules/edit/MerchantSettingsEditModule';
import { getTranslationKeys } from './translations';

export class MerchantSettingsModule extends AppModule {
  protected submodules = [
    new MerchantSettingsEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_MERCHANT_SETTINGS_ROUTE_NAME,
      path: 'merchants',
      permission: MERCHANT_SETTINGS_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'PendingWithdrawalsListPage',
    });

    router.addChildRoute(ADMIN_MERCHANT_SETTINGS_ROUTE_NAME, {
      name: ADMIN_MERCHANT_SETTINGS_LIST_ROUTE_NAME,
      path: '',
      component: () => import('./pages/MerchantSettingsPage/MerchantSettingsPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'GENERAL_SETTINGS_MERCHANT_SETTINGS'),
      to: {
        name: ADMIN_MERCHANT_SETTINGS_LIST_ROUTE_NAME,
      },
      permission: MERCHANT_SETTINGS_PERMISSIONS.SHOW,
      id: ADMIN_MERCHANT_SETTINGS_LIST_ROUTE_NAME,
      order: 150,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_MERCHANT_SETTINGS, getTranslationKeys);
  }
}
